<template>
  <el-select
    v-model="PerpectiveId"
    placeholder="Perspectiva"
    size="mini"
    filterable
    v-bind="$attrs"
    :disabled="loading"
    @change="OnPerspectiveChange"
    clearable
  >
    <el-option
      v-for="item in listOptionsObjectives"
      :key="item.Value"
      :label="item.Label"
      :value="item.Value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "PerspectiveSelectorFilter",
  props: {
    initialValue: {
      type: Number
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      PerpectiveId: null,
      listOptionsObjectives: [
        // { Value: 0, Label: "Todas" },
        { Value: 1, Label: "Financiera" },
        { Value: 2, Label: "Del cliente" },
        { Value: 3, Label: "Procesos internos" },
        { Value: 4, Label: "Desarrollo y Aprendizaje" }
      ]
    };
  },
  mounted() {
    this.PerpectiveId = this.initialValue;
  },
  updated() {
    //this.PerpectiveId = this.initialValue;
  },
  methods: {
    OnPerspectiveChange(value) {
      this.PerpectiveId = value;
      this.$emit("PerspectiveSelectorFilterChange", value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
